export default __webpack_public_path__ + "static/media/Logo_Agricultura.c6b33c80.png";